<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_iv"></a>First published in the United States of America in 2017 by Chronicle Books LLC.<br/>First published in Great Britain in 2017 by Gollancz.<br/>Gollancz is a division of The Orion Publishing Group.</p>
<p>Copyright © 2017 by Elizabeth May.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN 978-1-4521-2883-2 (hardcover)<br/>ISBN 978-1-4521-3106-1 (epub)</p>
<p>Typeset in Requiem.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107</p>
<p>Chronicle Books—we see things differently.<br/>Become part of our community at <a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?0ac75924